"use client";

import dynamic from "next/dynamic";
import BirthToolFormShell from "@/components/tool-shell/BirthToolFormShell";
import { useDeferredToolActivation } from "@/components/tool-shell/useDeferredToolActivation";

// Bundle-size discipline (2026-07-16 trim pass): MangalDoshaClient pulls the
// full BirthDetailsForm + PlaceAutocomplete + result/offer stack. Loading it
// via next/dynamic keeps that stack out of the en + hi route chunks and lets
// the bundler share ONE copy with the other deferred calculator islands.
// Height-reserving shell per rule 58; tool stays first-viewport per rule 43/61.
const MangalDoshaClient = dynamic(() => import("./MangalDoshaClient"), {
  ssr: false,
  loading: () => <BirthToolFormShell />,
});

export default function DeferredMangalDoshaClient({
  defaultLanguage = "en",
}: {
  defaultLanguage?: "en" | "hi";
}) {
  const { ready, activate } = useDeferredToolActivation();

  if (ready) return <MangalDoshaClient defaultLanguage={defaultLanguage} />;

  return (
    <BirthToolFormShell
      language={defaultLanguage}
      submitLabel={defaultLanguage === "hi" ? "Mangal Dosh check karein" : "Check Mangal Dosha"}
      onActivate={activate}
    />
  );
}
